import { map as _map } from 'lodash';
import DialogButton from '../models/dialog/dialogButton';
import DialogConfig from '../models/dialog/dialogConfig';

export default class DialogService {
  constructor($ngConfirm) {
    "ngInject";

    this.$ngConfirm = $ngConfirm;
  }

  single(dialogConfig, dialogButton) {
    return this.$ngConfirm({
      title: dialogConfig.title,
      content: dialogConfig.content,
      contentUrl: dialogConfig.contentUrl,
      type: dialogConfig.type,
      typeAnimated: true,
      buttons: {
        ok: {
          text: dialogButton.text,
          btnClass: dialogButton.btnClass,
          action: (scope, button) => {
            if (dialogButton.callback) {
              return dialogButton.callback(scope, button);
            }
            return true;
          }
        }
      }
    });
  }

  double(dialogConfig, dialogButton1, dialogButton2) {
    return this.$ngConfirm({
      title: dialogConfig.title,
      content: dialogConfig.content,
      contentUrl: dialogConfig.contentUrl,
      type: dialogConfig.type,
      typeAnimated: true,
      buttons: {
        button1: {
          text: dialogButton1.text,
          btnClass: dialogButton1.btnClass,
          action: (scope, button) => {
            if (dialogButton1.callback) {
              return dialogButton1.callback(scope, button);
            }
            return true;
          }
        },
        button2: {
          text: dialogButton2.text,
          btnClass: dialogButton2.btnClass,
          action: (scope, button) => {
            if (dialogButton2.callback) {
              return dialogButton2.callback(scope, button);
            }
            return true;
          }
        }
      }
    });
  }

  triple(dialogConfig, dialogButton1, dialogButton2, dialogButton3) {
    return this.$ngConfirm({
      title: dialogConfig.title,
      content: dialogConfig.content,
      contentUrl: dialogConfig.contentUrl,
      type: dialogConfig.type,
      typeAnimated: true,
      buttons: {
        button1: {
          text: dialogButton1.text,
          btnClass: dialogButton1.btnClass,
          action: (scope, button) => {
            if (dialogButton1.callback) {
              return dialogButton1.callback(scope, button);
            }
            return true;
          }
        },
        button2: {
          text: dialogButton2.text,
          btnClass: dialogButton2.btnClass,
          action: (scope, button) => {
            if (dialogButton2.callback) {
              return dialogButton2.callback(scope, button);
            }
            return true;
          }
        },
        button3: {
          text: dialogButton3.text,
          btnClass: dialogButton3.btnClass,
          action: (scope, button) => {
            if (dialogButton3.callback) {
              return dialogButton3.callback(scope, button);
            }
            return true;
          }
        }
      }
    });
  }  

  error(message) {
    return this.single(DialogConfig.red(message), DialogButton.ok());
  }
}



// WEBPACK FOOTER //
// ./client/app/common/services/dialogService.js